import {Routes} from '@angular/router';

import {AuthRequestBnbaccessComponent} from './auth-request-bnbaccess.component';
import {AuthRequestBnbaccessDetailComponent} from './auth-request-bnbaccess-detail.component';
import {AuthRequestBnbaccessPopupComponent} from './auth-request-bnbaccess-dialog.component';
import {AuthRequestBnbaccessDeletePopupComponent} from './auth-request-bnbaccess-delete-dialog.component';


export const authRequestRoute: Routes = [
    {
        path: 'auth-request-bnbaccess',
        component: AuthRequestBnbaccessComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.authRequest.home.title'
        }
    }, {
        path: 'auth-request-bnbaccess/:id',
        component: AuthRequestBnbaccessDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.authRequest.home.title'
        }
    }
];

export const authRequestPopupRoute: Routes = [
    {
        path: 'auth-request-bnbaccess-new',
        component: AuthRequestBnbaccessPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.authRequest.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'auth-request-bnbaccess/:id/edit',
        component: AuthRequestBnbaccessPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.authRequest.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'auth-request-bnbaccess/:id/delete',
        component: AuthRequestBnbaccessDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.authRequest.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess.route.ts